export default {
    handleSaveGameMethod(saveGameMethod) {
        if (this.params.slug === 'Shutter') {
            this.$set(this.params, 'locale', this.user.locale);
        }
        if (this.params?.mode === 'wordColumn' || this.params?.viewType === 'words') {
            this.checkIfEnoughWordsBeforeSaveAction(saveGameMethod);
            return;
        }
        saveGameMethod();
    },
    checkIfEnoughWordsBeforeSaveAction(saveGameMethod) {
        this.checkIfEnoughWords().then(data => {
            if (!data) {
                this.$toasted.error(this.$i18n.t('trainer.trainer_gameFormHelpText_selectMoreLetters'));
                return;
            }

            saveGameMethod();
        });
    },
};
